import { render, staticRenderFns } from "./TradeDocumentFileList.vue?vue&type=template&id=2fed398e"
import script from "./TradeDocumentFileList.vue?vue&type=script&lang=js"
export * from "./TradeDocumentFileList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports